import React from 'react';

export const PaymentPageSkeleton: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-8">
            {/* Header section skeleton */}
            <div className="mb-8">
                {/* Title skeleton */}
                <div className="h-10 w-64 bg-slate-200 rounded-md animate-pulse"></div>
            </div>

            {/* Tabs skeleton */}
            <div>
                {/* Mobile dropdown skeleton (hidden on desktop) */}
                <div className="sm:hidden">
                    <div className="h-10 w-full bg-slate-200 rounded-md animate-pulse"></div>
                </div>

                {/* Desktop tabs skeleton (hidden on mobile) */}
                <div className="hidden sm:block">
                    <div className="flex space-x-1 rounded-xl bg-white p-1.5 border border-slate-200">
                        {/* Generate 3 tab skeletons */}
                        {[...Array(2)].map((_, index) => (
                            <div
                                key={index}
                                className="w-full rounded-lg py-3 flex items-center justify-center space-x-2 bg-slate-100 animate-pulse"
                            >
                                {/* Icon skeleton */}
                                <div className="h-5 w-5 bg-slate-300 rounded-md"></div>
                                {/* Text skeleton */}
                                <div className="h-5 w-20 bg-slate-300 rounded-md"></div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Content panel skeleton */}
                <div className="mt-6 rounded-xl bg-white p-6 border border-slate-200">
                    {/* Optional tab description skeleton - only show if you have descriptions */}
                    <div className="mb-4">
                        <div className="h-7 w-40 bg-slate-200 rounded-md animate-pulse"></div>
                        <div className="h-5 w-96 bg-slate-200 rounded-md mt-2 animate-pulse"></div>
                    </div>

                    {/* Tab content skeleton - simple placeholder blocks */}
                    <div className="space-y-4">
                        <div className="h-8 w-full bg-slate-200 rounded-md animate-pulse"></div>
                        <div className="h-8 w-full bg-slate-200 rounded-md animate-pulse"></div>
                        <div className="h-8 w-2/3 bg-slate-200 rounded-md animate-pulse"></div>
                        <div className="h-8 w-full bg-slate-200 rounded-md animate-pulse"></div>
                        <div className="h-8 w-3/4 bg-slate-200 rounded-md animate-pulse"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};